(() => {
  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    if (select.dataset.sortReady) return;
    select.dataset.sortReady = 'true';
    select.addEventListener('change', () => {
      const url = new window.URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });
})();
